<template>
  <div class="recharge-content">
    <div class="recharge-content-head">
      <div class="recharge-head-left"><img :src="imgPath" alt="" srcset=""></div>
      <div class="recharge-head-right">
        <div>我的会员ID：{{userInfo.mid}}</div>
        <div>已充值{{userInfo.rechargetimes}}次，共{{userInfo.rechargeamount}}元</div>
        <div>当前余额：<span>￥{{userInfo.balance}}</span></div>
      </div>
    </div>
    <div class="recharge-content-list" v-if="shopRecharg.length!==0">
      <!-- <div v-if="shopflag!=='szty'&& shopflag !=='fzth'" class="send-text">首次充值，赠送{{sendData[current]}}1份</div> -->
      <div class="send-text">{{shopRecharg[current].coupontext}}</div>
      <el-row :gutter="16">
        <el-col v-for="(item,i) in shopRecharg" :key="i" :span="12">
          <el-card @click.native="clickCash(i)" shadow="always" :class="i === current ? 'active' :''">￥{{fullAmount(item.amount)}}</el-card>
        </el-col>
      </el-row>
      <div class="pay-rule" v-if="shopflag !=='hzhb'">
        会员卡使用规则：<br/>
        1、不可转让使用；<br/>
        2、会员金额必须大于或者等于买单金额才可享受会员优惠，会员金额不够抵扣买单金额时，可原价使用会员卡剩余金额，不享受会员折扣；<br/>
        （最终解释权归商家所有）
      </div>
      <div class="pay-rule" v-if="shopflag ==='hzhb'">
        会员卡使用规则：<br/>
        1、不可转让使用；<br/>
        2、会员金额必须大于或者等于买单金额才可享受会员优惠，会员金额不够抵扣买单金额时，可原价使用会员卡剩余金额，不享受会员折扣；<br/>
        （最终解释权归商家所有）<br/>
        3、逢周一、周三、周五会员结账可享受(普通茶、自带茶)免茶优惠，晚市五折点心优惠及抖音团购不参加以上优惠活动
      </div>
    </div>
    <div class="recharge-content-nodata" v-if="shopRecharg.length===0 && viewLoading">
      <span>{{shopflag === 'zhfh'?'系统更新升级中':'暂不支持此功能'}} </span>
    </div>
    <div class="recharge-btn" v-if="shopRecharg.length!==0">
      <!-- <div v-if="shopflag !=='szty' && shopflag !=='fzth' " @click="enterFreebie" class="recharge-present-btn">
        <span>充值大赠送！逢充1000送200元电子劵</span>
        <div class="recharge-icon"></div>
      </div> -->
      <!-- <div v-if="shopflag ==='szty'" @click="enterFreebie" class="recharge-present-btn">
        <span>会员可享全单九五折，特价菜式和优惠套餐除外。</span>
      </div> -->
      <!-- <div v-if="shopflag ==='fzth'" @click="enterFreebie" class="recharge-present-btn">
        <span>会员享受茶点5折优惠同时享受炒菜8.8折</span>
      </div> -->
     <!-- <div v-if="shopflag ==='zhfh' " @click="enterFreebie" class="recharge-present-btn">
        <span>充值送钱还打折</span>
        <div class="recharge-icon"></div>
      </div> -->
      <div class="pay-contnet">
        <div class="pay-top">
          <div class="pay-top-left">
            <el-button :disabled="!checked" @click="requestPreRecharge" type="success">微信充值</el-button>
          </div>
          <!-- <div class="pay-top-right">
            <el-button :disabled="!checked" type="primary">支付宝充值</el-button>
          </div> -->
        </div>
        <div class="pay-mid">余额不可与现金，刷卡等共用，不可与其他优惠同享</div>
        <div class="pay-bottom">
          <el-checkbox v-model="checked"></el-checkbox><span style="cursor: pointer;" @click="show = true">我已阅读并同意服务条款</span>
        </div>
      </div>
    </div>
    <el-dialog title="服务协议" class="clause-dialog" fullscreen :visible.sync="show">
      <div>
        <p>1 本协议及储值消费服务由本店提供。请充分阅读、理解并接受本协议的全部内容，一旦用户使用本服务，即表示用户同意遵循本协议之所有约定。</p>
        <p>2 本店在必要时可修改本协议，并在本店公众号上进行公告，即公告之日起生效。如您继续使用本服务，则视为您已接受修订的协议。</p>
        <p>3 在您同意接受本协议时，您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织；本协议内容不受您所属国家或地区的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。</p>
        <p>4 本系统用户的资金交易款项，由本店收取。若涉及用户资金问题请联系本店沟通。</p>
        <p>5 用户同意在本店的微信公众平台上发生的所有资金交易行为，本店有权从微信中获取您的头像，昵称等相关的信息。</p>
        <p>6 在本店的微信公众平台上储值金额只能用作消费结账时使用，不能抵其他费用，仅限用户本人使用，如用户自行将平台账号信息泄露给第三方，由此产生的资金损失等问题，由用户本人承担。</p>
        <p>7 您理解并同意，本店有权自主决定经营策略。在本店发生合并、分立、收购、资产转让时，本店可向第三方转让本服务下相关资产；本店也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行；本店也可在单方通知您后，限期内到指定地点现金补偿，逾期不再通知，作自动放弃处理。</p>
        <p>8 若您和本店之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本店所在地有管辖权的人民法院起诉。</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUserInfo } from '@/views/mobile/MemberCenter/apis'
import { preRecharge, getRechargeCouponList } from '@/views/mobile/PublicApp/apis'
const shopNameGroup = {
  gzahh: require('../assets/images/logo.png'),
  gzwyh: require('../assets/images/logo.png'),
  zhfh: require('../assets/images/logo.png'),
  hzhb: require('../assets/images/logo.png'),
  fzth: require('../assets/images/logo.png'),
  szty: require('../assets/images/szty.jpg'),
  test: require('../assets/images/logo.png'),
  test2: require('../assets/images/logo.png')
}

// const shopRechargGroup = {
//   gzahh: {
//     // cashData: [500, 1000, 2000, 3000, 5000, 10000, 20000],
//     cashData: [500, 1000, 3000],
//     sendData: [
//       '送煎堆1份',
//       '送五谷烩花胶1份',
//       '送指定红酒一支'
//     ]
//   },
//   gzwyh: {
//     cashData: [500, 1000, 2000, 3000, 20000],
//     sendData: ['送空心煎堆一份', '送红枣糕半打', '送浓汤花胶鸡汤例', '送法国红酒一支', '芝士伊面焗波龙一只（免服务费）']
//   },
//   zhfh: {
//     cashData: [500, 1000, 3000, 5000, 10000],
//     sendData: [
//       '送椰香姜汁糕1份',
//       '送美极虾1份',
//       '送清蒸龙趸鱼1条',
//       '送芝士伊面龙虾1只',
//       '送浓汤鸡煲翅1例'
//     ]
//   },
//   hzhb: {
//     cashData: [500, 1000, 2000, 3000, 5000, 10000],
//     // cashData: [],
//     sendData: ['送100元现金券', '送200现金券', '送400现金券', '送600现金券', '送1000现金券', '送2000现金券']
//   },
//   fzth: {
//     cashData: [500, 1000, 2000, 3000, 5000, 10000],
//     sendData: [
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份'
//     ]
//   },
//   szty: {
//     cashData: [2000, 3000, 5000, 10000],
//     sendData: ['', '', '', '']
//   },
//   test: {
//     cashData: [500, 1000, 2000, 3000, 5000, 10000],
//     sendData: ['', '', '', '', '', '']
//   }
// }

export default {
  data () {
    return {
      shopRecharg: [],
      current: 0,
      shopName: '',
      shopflag: '',
      checked: true,
      show: false,
      userInfo: {},
      imgPath: '',
      viewLoading: false
    }
  },
  methods: {
    fullAmount (amount) {
      return parseInt(amount)
    },
    requestUserInfo () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then((result) => {
          this.loading.hide()
          if (result) {
            this.userInfo = result.data
            this.shopName = result.data.ext.shopname
            this.shopflag = result.data.ext.shopflag
            // this.shopflag = 'zhfh'
            this.imgPath = shopNameGroup[this.shopflag]
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
              // this.cashData = [2000, 3000, 5000, 10000]
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
            // this.shopRecharg = shopRechargGroup[this.shopflag]
            // if (!this.shopRecharg) {
            //   this.shopRecharg = shopRechargGroup.test
            // }
          }
          this.viewLoading = true
        })
        .catch((error) => {
          if (error) {
            this.viewLoading = true
            this.loading.hide()
          }
        })
    },
    onBridgeReady () {
      let that = this
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        window.jsPayParameters,
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            that.$router.push('/memberCenter')
          }
        }
      )
    },
    requestPreRecharge () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('amount', this.shopRecharg[this.current].amount)
      data.append('shop_id', this.$route.query.id)
      preRecharge(data).then((result) => {
        if (result) {
          // 参数先缓存起来
          window.jsPayParameters = result.data
          // 起调支付
          if (typeof WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
              document.addEventListener(
                'WeixinJSBridgeReady',
                this.onBridgeReady,
                false
              )
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
              document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
            }
          } else {
            this.onBridgeReady()
          }
        }
      })
    },
    requestRechargeCouponList () {
      getRechargeCouponList().then((result) => {
        if (result) {
          this.shopRecharg = result.data.list
        }
      })
    },
    clickCash (i) {
      this.current = i
    },
    enterFreebie () {
      this.$router.push('/public/freebie')
    }
  },
  mounted () {
    this.requestUserInfo()
    this.requestRechargeCouponList()
  },
  created () {
    // let shop = window.location.hostname.split('.')[0]
    // if (shop === 'szty') {
    //   document.title = '陶源酒家'
    //   this.cashData = [2000, 3000, 5000, 10000]
    // } else {
    //   document.title = '香港富临皇宫'
    // }
  }
}
</script>
<style lang="less">
.nut-dialog-ok {
  background: linear-gradient(315deg, #fff 0%, #fff 100%);
}
.nut-dialog-ok:active {
  background: inherit;
}
.clause-dialog .el-dialog__body {
  padding-top: 0;
}
.recharge-content {
  font-size: 15px;
  height: 100%;
  .recharge-content-head {
    padding: 32px 0 32px 32px;
    overflow: hidden;
    border-bottom: 1px solid #ddd;
    .recharge-head-left {
      height: 80px;
      width: 80px;
      float: left;
      margin-right: 32px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      img {
        display: block;
        float: left;
        width: 100%;
      }
    }
    .recharge-head-right {
      float: left;
      line-height: 26px;
      span {
        color: #f00;
      }
    }
  }
  .recharge-content-list {
    padding: 16px;
    .send-text {
      color: #4fc08d;
      margin-top: 10px;
    }
    .el-col {
      margin-top: 10px;
    }
    .el-card.active {
      color: #4fc08d;
      border: 1px solid #4fc08d;
    }
    .el-card__body {
      padding: 10px;
      text-align: center;
    }
  }
  .recharge-content-nodata{
    padding-top: 50px;
    text-align: center;
  }
  .recharge-btn {
    position: fixed;
    bottom: 0;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 16px 16px 24px 16px;
    width: 100%;
    max-width: 750px;
    .recharge-present-btn {
      position: absolute;
      top: -40px;
      left: 0;
      height: 40px;
      width: 100%;
      border-top: 1px solid #f00;
      border-bottom: 1px solid #f00;
      color: #f00;
      line-height: 40px;
      font-size: 16px;
      text-align: center;
      background: rgb(254, 250, 216);
      cursor: pointer;
      .recharge-icon {
        position: absolute;
        height: 26px;
        width: 26px;
        top: 50%;
        margin-top: -13px;
        right: 0;
        background: url(../assets/images/right-red.png) center no-repeat;
        background-size: contain;
      }
    }
    .pay-contnet {
      .pay-top {
        overflow: hidden;
        .pay-top-left,
        .pay-top-right {
          float: left;
          width: 100%;
          text-align: center;
          padding: 0;
          // padding-right: 8px;
          .el-button {
            width: 100%;
            font-size: 18px;
          }
        }
        .pay-top-right {
          padding: 0;
          padding-left: 8px;
        }
      }
      .pay-mid {
        font-size: 12px;
        margin: 12px 0;
        text-align: center;
      }
      .pay-bottom {
        text-align: center;
        span {
          margin-left: 8px;
          font-size: 14px;
        }
      }
    }
  }
  .pay-rule{
    font-size: 13px;
    margin-top: 12px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/components/Recharg.vue